/** React Query stale / gc policies for replacement data layer. Times in ms. */
export const policies = {
  subscription: {
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    staleTimeExtended: 1000 * 60 * 10,
  },
  menu: {
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
  },
  calendar: {
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
  },
  config: {
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
  },
  notifications: {
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
  },
  addresses: {
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 15,
  },
  plansCatalog: {
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 60,
  },
  pendingSubscription: {
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 10,
  },
} as const;
